import React, { useCallback, useState } from "react"
import { useAllReportsContext } from "../contextProviders/allReportsContext"
import { useNavigate } from "react-router-dom"
import { dataSource } from "../../../services/dataSource"
import { useUserContext } from "../contextProviders/userContext"
import DataDisplayTable from "../../dataDisplayTable"
import { CLI_V2, LANG_V2, PROP, REP_V2, USR,REP_V2_NAVIGATION } from "../../../shared/Data/typeDirs"
import { useEffect } from "react"
import { DateToFormattedString } from "../../../shared/utils"
import { ReportV2 } from "../../../shared/Objects/newReportObjects/report_v2"
import { ClientV2 } from "../../../shared/Objects/newReportObjects/client_v2"
import { NewControlManager } from "../../newControlManager"
import { ModalContainer } from "../../newControlManager/controlWrappers/containers/modal"
import { CreateReportHeaderWrapper } from "../../newControlManager/controlWrappers/reports_v2/createReportHeader"
import { createVirtualSetsForReport } from "../../../services/dbGalleryRequests"
import {
  Box,
  Button as JoyButton,
  Checkbox,
  IconButton,
  Input,
  Sheet,
  Typography,
  Dropdown, Menu, MenuButton, MenuItem, ListDivider, ListItem,
  Badge
} from '@mui/joy'
import { Row, Col } from 'react-bootstrap'
import Collapse from '@mui/material/Collapse'
import Paper from '@mui/material/Paper'
import AddIcon from '@mui/icons-material/Add'
import FilterListIcon from '@mui/icons-material/FilterList'


const cols = [
  { accessor: 'dirName', show: false },
  { accessor: '_id', show: false },
  { Header: 'Name', accessor: 'name' },
  { Header: 'Client', accessor: 'client' },
  { Header: 'Modified', accessor: 'modified', Cell: getDateForTableCell },
  { Header: 'Modified By', accessor: '_modifiedBy' },
  { Header: 'Created', accessor: 'created', Cell: getDateForTableCell },
  { Header: 'Created By', accessor: '_createdBy' },
]

function getDateForTableCell(data) {
  return data.value ? DateToFormattedString(new Date(data.value)) : ''
}


export function ReportTableV2(props) {
  const { reports_v2: allReports_v2, clients_v2: allClients, [USR]: allUsers, [PROP]: allProperties } = useAllReportsContext()
  const navigate = useNavigate()
  const { user } = useUserContext()
  const [filter, setFilter] = useState('')
  const [filteredReports, setFilteredReports] = useState(allReports_v2)
  const [assignedReportsOnly, setAssignedReportsOnly] = useState(false)
  const [showNewReportModal, setShowNewReportModal] = useState(false)
  const [showEditClientModal, setShowEditClientModal] = useState(false)
  const [newClientData, setNewClientData] = useState({ saved: false })
  const [newReportData, setNewReportData] = useState({})
  const [showFilters, setShowFilters] = useState(false)

  const mapAllReports = useCallback((ar, u) => {
    return ar.map(itm => {
      let modifiedUser = u.find(usr => usr._id === itm._modifiedBy)
      let createdUser = u.find(usr => usr._id === itm._createdBy)
      return {
        name: itm.name,
        dirName: itm.dirName,
        client: { ...allClients.find(cli => cli._id === itm.client) }.name,
        modified: itm.modified,// new Date(itm.modified).toLocaleString(),
        created: itm.created, //new Date(itm.created).toLocaleString(),
        _modifiedBy: modifiedUser && `${modifiedUser.firstName} ${modifiedUser.lastName}`,
        _createdBy: createdUser && `${createdUser.firstName} ${createdUser.lastName}`,
        users: itm[USR] && itm[USR].reduce((prev, cur, idx) => {
          const i = u.findIndex(usr => usr._id === cur)
          return ~i ? [...prev, u[i]._id] : prev
        }, []),
        _id: itm._id
      }
    })//.sort((a, b) => a.name.toLowerCase() <= b.name.toLowerCase() ? -1 : 1)
  }, [allClients])

  useEffect(() => {
    const t_id = setTimeout(() => {
      let reports = mapAllReports(allReports_v2, allUsers)
      setFilter('')
      setFilteredReports(reports)
    })

    return () => {
      clearTimeout(t_id)
    }
  }, [allReports_v2, allClients, allUsers, mapAllReports])

  function filterReports(f = '', assignedToggle = false) {
    let ar = f.includes(filter) && assignedToggle ? filteredReports : mapAllReports(allReports_v2, allUsers)
    setFilteredReports(ar.filter(itm =>
      itm.name.toLowerCase().includes(f.toLowerCase()) && (!assignedToggle || itm.users.includes(user._id))
    ))
    setFilter(f)
    setAssignedReportsOnly(assignedToggle)
  }

  async function initNewReport() {
    let report = new ReportV2()
    let languages = await dataSource('remDb')[LANG_V2].toFlatArray()
    let source = {
      [LANG_V2]: languages,
      users: allUsers,
      [CLI_V2]: allClients,
      [PROP]: allProperties,
      reportType: ['PNA', 'O&M', 'Accesibility'],
      [REP_V2]: allReports_v2
    }
    console.log('setting new report data', { report, languages, source })
    setNewReportData({ report, source, schemas: report.getSchemas(), contents: report.getCreateReportContents() })
    setShowNewReportModal(true)
  }

  async function newRep({ controls, schemas, source }) {
    let client, rep, property
    try{
      if( controls[0].duplicate ){
        let {duplicate:_id, name, [USR]:users} = controls[0]
        console.log('attempting to duplicate report', _id, name, users, controls)
        rep = await dataSource('remDb')[REP_V2].duplicate({_id, name, [USR]:users || []})
        await createVirtualSetsForReport(rep.name, user.token)
        console.log('duplicated report and got this', rep)
      }else{
        client = source[CLI_V2].find(itm => itm._id === controls[0][CLI_V2])
        property = source[PROP].find(itm => itm._id === controls[0][PROP])
        rep = ReportV2.constructFromCreateReportContents(controls[0], client, property)
        console.log('sending rep to be created', rep)
        await dataSource('remDb')[REP_V2].put(rep)
        await createVirtualSetsForReport(rep.name, user.token)
      }
      navigate(`/${REP_V2_NAVIGATION}/${rep._id}`)
    }catch(e){
      console.log('failed creating new reports_v2', e)
    }
  }

  async function saveNewClient({ controls }) {
    let data = controls[0]
    let newClient = new ClientV2({ ...newClientData.client, ...data })
    let res = await dataSource('remDb')[CLI_V2].put(newClient)
    if (!newClientData.saved) {
      setNewClientData({ ...newClientData, client: newClient, contents: newClient.getLogoContents() })
    } else {
      setShowEditClientModal(false)
    }
  }

  async function handleRowClick(row) {
    navigate(`/${REP_V2_NAVIGATION}/${row._id}`)
  }

  const handleApplyFilters = () => {
    filterReports(filter, assignedReportsOnly)
    setShowFilters(false)
  }

  const handleClearFilters = () => {
    setAssignedReportsOnly(false)
    filterReports(filter, false)
    setShowFilters(false)
  }

  const isFiltered = assignedReportsOnly || (filter && filter.trim().length > 0)

  return (
    <>
      <DataDisplayTable
        data={filteredReports}
        cols={cols}
        onClickEntry={handleRowClick}
        headerChildren={(
          <Box sx={{ width: '100%', 'margin': '0 0 16px 0' }}>
            <Row className="align-items-center g-2">
              <Col xs={12} md={6} className="d-flex align-items-center gap-3">
                <Typography level="h4">Reports</Typography>
                <Box>
                  {['inspector', 'admin'].includes(user.role) ? (
                    <JoyButton  color="primary" 
                    startDecorator={<AddIcon/>} onClick={initNewReport}
                    size="sm"
                    variant="outlined"
                    className={"btn-custom-primary-outlined"}>
                      New Report
                    </JoyButton>
                  ) : null}
                </Box>
              </Col>
              <Col xs={12} md={6} className="d-flex align-items-center justify-content-end gap-2">
                <Input
                  placeholder="Search reports by name..."
                  size="sm"
                  value={filter}
                  onChange={evt => filterReports(evt.target.value, assignedReportsOnly)}
                  fullWidth
                />
                <Dropdown open={showFilters} onOpenChange={(_, isOpen) => setShowFilters(isOpen)}>
                  <Badge
                    variant="solid"
                    color="primary"
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    badgeInset="3px 4px 0 0"
                    invisible={!isFiltered}
                    
                  >
                    <MenuButton size="sm" variant="outlined" color="neutral" startDecorator={<FilterListIcon/>}>
                      Filters
                    </MenuButton>
                  </Badge>
                  <Menu placement="bottom-end" sx={{ minWidth: 280 }}>
                    <MenuItem disabled><Typography level="body-sm">Status</Typography></MenuItem>
                    
                    <MenuItem onClick={(e) => e.stopPropagation()} onMouseDown={(e)=>e.stopPropagation()}>
                      <ListItem nested sx={{ p: 0 }} onClick={(e)=>e.stopPropagation()} onMouseDown={(e)=>e.stopPropagation()}>
                        <Checkbox
                          checked={assignedReportsOnly}
                          onChange={() => setAssignedReportsOnly(v => !v)}
                          label="Show my assigned reports"
                        />
                      </ListItem>
                    </MenuItem >
                    <ListDivider />
                    <MenuItem sx={{ background: 'none !important' }}>
                      <Box sx={{ display: 'flex', gap: 1, width: '100%', justifyContent: 'flex-end' }}>
                        <JoyButton  className="btn-custom-primary-outlined" color="primary" 
                        size="sm" variant="outlined" 
                        onClick={() => { handleApplyFilters(); setShowFilters(false); }}>Apply Filters</JoyButton>
                        <JoyButton color="neutral" size="sm" variant="outlined" 
                        onClick={() => { handleClearFilters(); setShowFilters(false); }}>Clear All</JoyButton>
                      </Box>
                    </MenuItem>
                  </Menu>
                </Dropdown>
              </Col>
            </Row>
          </Box>
        )}
      />
      <NewControlManager
        onSubmit={newRep}
        content={newReportData.contents}
        schemas={newReportData.schemas}
        source={newReportData.source}
        objectMetadata={newReportData.report}
        options={{modules: {container: ModalContainer, header: CreateReportHeaderWrapper}, show: showNewReportModal, 
        setShow: setShowNewReportModal, isModal: true }}
      />
      <NewControlManager
        onSubmit={saveNewClient}
        content={newClientData.contents}
        schemas={newClientData.schemas}
        source={newClientData.source}
        objectMetadata={newClientData.client}
        options={{
          modules: {container: ModalContainer}, show: showEditClientModal, 
          isModal: true,
          setShow: (arg) => {
            setShowEditClientModal(arg)
          }
        }}
      />
    </>
  )
}

